import * as types from './actionTypes';
import * as eventTypes from './eventTypes';
import initialState from '../../../../../reducers/initialState';
import { emptyObject } from 'constants/emptyConst';

const contactPersonsReducer = (state = initialState.currentOffer.clientContactPersonsData, action) => {
  switch (action.type) {
    case types.LOAD_CONTACT_PERSONS_STARTED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...state[key],
        loading: true,
        loaded: false,
        summaryLoaded: result[key]?.summaryLoaded || false,
        summary: result[key]?.summary || null
      };
      return result;
    }

    case types.LOAD_CONTACT_PERSONS_SUCCEEDED: {
      const { key } = action;
      let result = { ...state };
      result[key] = { ...state[key], loading: false, loaded: true };
      return result;
    }

    case types.LOAD_CONTACT_PERSONS_FAILED: {
      const { key } = action;
      let result = { ...state };
      result[key] = {
        ...result[key],
        loading: false,
        loaded: false
      };
      return result;
    }

    case eventTypes.CONTACT_PERSONS_INVALIDATED: {
      const { partnerId } = action.event.eventBody;
      let result = { ...state };
      result[partnerId] = {
        ...result[partnerId],
        loading: false,
        loaded: false,
        summaryLoaded: false
      };

      return result;
    }

    case types.LOAD_CONTACT_PERSONS_SUMMARY_SUCCEEDED: {
      const { contactPersonsSummary, key } = action;
      let result = { ...state };
      result[key] = {
        ...result[key],
        summaryLoaded: true,
        summary: contactPersonsSummary
      };
      return result;
    }

    case eventTypes.ALL_CONTACT_PERSONS_INVALIDATED: {
      return emptyObject;
    }

    case types.UPDATE_CONTACT_PERSONS_SUCCEEDED: {
      const { partnerId } = action;
      let result = { ...state };
      result[partnerId] = { ...result[partnerId], loading: false, loaded: true };
      return result;
    }

    default:
      return state;
  }
};

export default contactPersonsReducer;
